<template >
  <div :class="classObj">
    <label v-if="label" :for="fieldId" v-html="label" />
    <div class="input-group">
      <span
        class="input-group-addon pointer"
        :disabled="min >= modelValue || minTotal >= total ? '' : null"
        @click.prevent="minus"
        >-</span
      >
      <input
        ref="input"
        class="form-control"
        :required="required"
        :id="fieldId"
        type="text"
        :value="modelValue"
        @input="(e) => changeValue(e.target.value)"
      />
      <span
        class="input-group-addon pointer"
        :disabled="max <= modelValue || maxTotal <= total ? '' : null"
        @click.prevent="plus"
        >+</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "InputPlusField",
  props: {
    class: {
      type: [String, Object],
      default: "",
    },
    label: String,
    modelValue: Number,
    required: Boolean,
    id: String,
    min: Number,
    max: Number,
    minTotal: Number,
    maxTotal: Number,
    total: Number,
  },
  emits: ["update:modelValue", "input"],
  computed: {
    fieldId: function () {
      if (this.id) {
        return this.id;
      }
      return "id-" + (Math.random() + 1).toString(36).substring(2);
    },
    classObj: function () {
      var obj = {};
      if (typeof this.class == "string") {
        obj[this.class] = true;
      } else {
        obj = this.class;
      }
      obj["form-group"] = true;
      if (this.required) {
        obj["required"] = true;
      }
      return obj;
    },
  },
  data: function () {
    return {};
  },
  methods: {
    changeValue(value) {
      value = Number(value);
      if(isNaN(value)){
        value = 0;
      }
      if (this.min != null && this.min > value) {
        value = this.min;
      }
      if (this.max != null && this.max < value) {
        value = this.max;
      }
      if (this.total != null) {
        const total = this.total - this.modelValue + value + 0;
        if (this.minTotal != null && this.minTotal > total) {
          value = this.minTotal - total;
        }
        if (this.maxTotal != null && this.maxTotal < total) {
          value = value - total + this.maxTotal;
        }
      }

      this.$refs["input"].value = value;
      this.$emit("update:modelValue", value);
      this.$emit("input", value);
    },
    plus() {
      this.changeValue(this.modelValue + 1);
    },
    minus() {
      this.changeValue(this.modelValue - 1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
